





import { defineComponent } from '@vue/composition-api';

import PageColumnWithWithdrawUpdate from '@/components/Withdraw/PageColumnWithWithdrawUpdate.vue';

const Update = defineComponent({
  components: { PageColumnWithWithdrawUpdate },
  // setup() {},
});

export default Update;
